<template>
  <div>
    <!--select city timed component -->
  </div>
</template>
<script>
/* global $ */
export default {
  props: {
    delay: Number
  },
  data() {
    return {
      timeoutHandler: null
    }
  },
  mounted() {
    if (this.delay) {
      const $this = this;
      this.timeoutHandler = setTimeout(() => {
        if ($("body").hasClass("popupisopen")) {
          return;
        }
        $this.$store.dispatch('showSelectCity')
      }, this.delay || 8000);
    }
  },
  unmounted() {
    if (this.timeoutHandler)
      clearTimeout(this.timeoutHandler);
  }
}
</script>